import React from 'react';
import JobForm from '../components/JobForm';

const EditJob = () => {
  return <JobForm isEdit={true} />;
};

export default EditJob;
